var angular = require('angular');
angular.module('pitch.search')
.config(function($httpProvider, config) {
    $httpProvider.interceptors.push(function() {
        return {
            'request': function(c) {
                if (c.url.indexOf(config.apiUri + '/search') !== -1 &&
                    c.params
                ) {
                    //some search parameters need to be sent to the api using the [] notation.. even if there's only
                    //a single value. The symfony form will otherwise not map the value to the correct form field.
                    var arrayParams = ['categoryIds', 'versionIds', 'keywordIds', 'fields', 'entityCodes'];

                    angular.forEach(c.params, function(v, k) {
                        if (v !== undefined &&
                            arrayParams.indexOf(k) !== -1 &&
                            !angular.isArray(v) &&
                            k.substr(-2) !== '[]'
                        ) {
                           c.params[k + '[]'] = v;
                           delete c.params[k];
                        }
                    });
                }

                return c;
            }
        };
    });
});


// WEBPACK FOOTER //
// ./src/SearchClientBundle/Resources/js/angular/services/SearchRequestInterceptor.js